import localFont from 'next/font/local'

/**
 * Брэндийн фонт — Google Sans, public/fonts дотор өөрсдөө байршуулсан.
 *
 * Гарчиг, бичвэр хоёулаа НЭГ гэр бүл. Өмнө нь бичвэрт Raleway байсныг
 * больсон: түүний тоонууд өөр өөр өндөртэй (old-style figures) тул
 * үзүүлэлт, үнэ, хүснэгтэд жигд бус харагддаг байв.
 *
 * ⚠️ `src`-ыг тогтмолд гаргаж БОЛОХГҮЙ. `next/font/local` нь дуудлагыг
 * хөрвүүлэлтийн үед задалдаг тул хувьсагчаар дамжуулбал
 * "missing field `src`" гэж бүтэн апп унана. Тиймээс давхардсан ч
 * шууд бичнэ — хоёулаа ижил файл заадаг учир хөтөч нэг л удаа татна.
 *
 * `--font-brand-body` хувьсагчийг хадгалсан нь загварын тохируулагч
 * (FONT_CONFIG, themeConfig.bodyFont) эвдрэхээс сэргийлсэн хэрэг.
 */

export const fontHeading = localFont({
  src: [
    {
      // GRAD/opsz/wght гурван тэнхлэгтэй variable фонт — жин нь 100-900
      path: '../../public/fonts/Google_Sans/GoogleSans-VariableFont_GRAD,opsz,wght.ttf',
      weight: '100 900',
      style: 'normal'
    },
    {
      path: '../../public/fonts/Google_Sans/GoogleSans-Italic-VariableFont_GRAD,opsz,wght.ttf',
      weight: '100 900',
      style: 'italic'
    }
  ],
  display: 'swap',
  variable: '--font-brand-heading',
  fallback: ['system-ui', 'sans-serif']
})

export const fontBody = localFont({
  src: [
    {
      path: '../../public/fonts/Google_Sans/GoogleSans-VariableFont_GRAD,opsz,wght.ttf',
      weight: '100 900',
      style: 'normal'
    },
    {
      path: '../../public/fonts/Google_Sans/GoogleSans-Italic-VariableFont_GRAD,opsz,wght.ttf',
      weight: '100 900',
      style: 'italic'
    }
  ],
  display: 'swap',
  variable: '--font-brand-body',
  fallback: ['system-ui', 'sans-serif']
})

export const brandFonts = [fontHeading, fontBody]
